import {
    conferenceLocalStorage,
    conferenceSessionStorage,
    createUtcMoment,
    generateRandomString,
} from "conference/tools";
import { createStorageObjectItemContext } from "conference/storageObjectItemManager";
import { useEffect, useState } from "react";
import { useMediaDevices } from "@dvrt/web-phone-client";
import { Duration } from "moment";

const datetimeFormat = "YYYY-MM-DD HH:mm";

export const formatDateTime = (value: string) => {
    return createUtcMoment(value).local().format(datetimeFormat);
};

export const Settings = createStorageObjectItemContext(conferenceSessionStorage, "meetingPageSettings");

export const useSettings = Settings.getterHook;

export const useSelectedVideoStream = (autoClose: boolean = true): MediaStream => {
    const [stream, setStream] = useState<MediaStream>();
    const mediaDevices = useMediaDevices();

    const closeStream = () => {
        if (!stream) return;
        for (const track of stream.getTracks()) track.stop();
    };

    const deviceId = conferenceLocalStorage.selectedMediaDevices?.videoinput ?? mediaDevices.defaults.videoinput;

    const isDeviceValid = mediaDevices.devices.videoinput.filter((d) => d.deviceId === deviceId).length > 0;

    useEffect(() => {
        closeStream();
        console.debug("getting user media without constraints");
        navigator.mediaDevices
            .getUserMedia({ video: { deviceId: { exact: deviceId } } })
            .then(setStream)
            .catch((e) => {
                console.error(e);
                if (stream) setStream(null);
            });
    }, [deviceId, isDeviceValid]);

    useEffect(() => {
        if (autoClose) return closeStream;
        return undefined;
    }, [!stream]);

    return stream;
};

// export const useVideoTrack = (deviceId: string): MediaStreamTrack => {
//     const [track, setTrack] = useState<MediaStreamTrack>();
//     const mediaDevices = useMediaDevices();
//
//     const closeTrack = () => {
//         if (track)
//             track.stop();
//     };
//
//     const isDeviceValid = mediaDevices.devices.videoinput.filter(d => d.deviceId === deviceId).length > 0;
//
//     useEffect(() => {
//         closeTrack();
//         navigator.mediaDevices.getUserMedia({video: {deviceId: {exact: deviceId}}})
//             .then(stream => setTrack(stream.getVideoTracks()[0]))
//             .catch(e => {
//                 console.error(e);
//                 if (track)
//                     setTrack(null);
//             });
//
//     }, [deviceId, isDeviceValid]);
//
//     useEffect(() => closeTrack, [track]);
//
//     return track;
// };

export const useForcedValidMediaSettings = () => {
    const settings = useSettings();
    const mediaDevices = useMediaDevices();

    useEffect(() => {
        if (!mediaDevices.initialized) return;

        if (!mediaDevices.capabilities.videoinput && settings.video) settings.video = false;

        if (!mediaDevices.capabilities.audioinput && settings.audio) settings.audio = false;
    }, [mediaDevices.capabilities]);
};

export function getClientIdentifier(): string {
    return (conferenceSessionStorage.clientIdentifier ??= generateRandomString(10));
}

export const clientIdParamName = "client-id";

export const zeroPad = (num: number, places: number) => String(num).padStart(places, "0");

export const formatDuration = (d: Duration) => `${zeroPad(d.minutes(), 2)}:${zeroPad(d.seconds(), 2)}`;
